<div class="dropdown-wrap">
  <app-button
    #btn
    [type]="'button'"
    [iconClass]="'fa fa-download'"
    [ariaLabel]="'general.download' | translate"
    [loading]="isLoading()"
    [disabled]="isLoading()"
    (clicked)="onOpen($event)"
    [btnClass]="'btn btn-falcon-primary border-0 shadow-none bg-transparent '"
  ></app-button>
</div>
